export default __webpack_public_path__ + "static/media/amor.61464ed0.svg";